<template>
  <v-app>
    <v-card
      v-if="mediaQuery === 'pc'"
      class="v-card v-navigation"
      max-width="70"
      min-height="200"
      tile
    >
      <v-list flat>
        <v-list-item-group class="v-list-item-group" mandatory>
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            class="v-list-item"
            @click="handleItemClick(item.name)"
          >
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-list-item-icon class="v-list-item-icon" v-on="on">
                  <v-icon v-text="item.icon" class="v-icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content class="v-list-item-content"></v-list-item-content>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
    <v-card class="v-card v-navigation" v-if="mediaQuery === 'sp'">
      <v-icon
        size="40"
        v-text="item.icon"
        v-for="(item, i) in items"
        :key="i"
        @click="handleItemClick(item.name)"
        class="v-icon"
      ></v-icon>
    </v-card>
  </v-app>
</template>

<script>
export default {
  name: "Navigation",
  components: {},
  data: () => ({
    mediaQuery: "",
    items: [
      {
        icon: "mdi-home",
        name: "Home",
        path: "/",
        title: "ホーム"
      },
      {
        icon: "mdi-clipboard-list-outline",
        name: "ManageTask",
        path: "/manageTaskPage",
        title: "タスク管理"
      },
      {
        icon: "mdi-border-all",
        name: "Matrix",
        path: "/matrixPage",
        title: "時間管理のマトリックス"
      }
    ]
  }),
  methods: {
    handleItemClick(target) {
      switch (target) {
        case "Home":
          this.$router.push("/", () => {});
          break;
        case "ManageTask":
          this.$router.push("/manageTask", () => {});
          break;
        case "Matrix":
          this.$router.push("/matrix", () => {});
          break;
        default:
      }
    }
  },
  created() {
    if (window.innerWidth > 415) {
      this.mediaQuery = "pc";
    } else if (window.innerWidth <= 415) {
      this.mediaQuery = "sp";
    }
  }
};
</script>

<style lang="scss" scoped>
.v-navigation {
  position: fixed;
  z-index: 20;
}

.v-card {
  padding-top: 85px;
  height: 100vh;
}

.v-list-item {
  padding-left: 20px;
  color: $primary;
}

.v-list-item-icon {
  padding-left: 5px;
}

.v-tooltip__content {
  font-size: 12px;
}

.v-list-item--active {
  border-right: 2px solid $primary;
}
@media screen and (max-width: 415px) {
  .v-navigation {
    position: fixed;
    z-index: 20;
    bottom: 0;
  }
  .v-card {
    padding: 0px;
    height: 65px;
    width: 100vw;
    border-radius: 0px !important;
  }
  .v-icon{
  }
}
</style>
